import { FC } from 'react';

export type SidebarRelatedProps = {
  title: string;
  articles: Array<{ title: string; href?: string }>;
}

const SidebarRelated: FC<SidebarRelatedProps> = ({
  title,
  articles,
}) => {


  return (
    <div className="flex flex-col">
      <h3 className="text-micro2 uppercase text-blue-900">{title}</h3>
      <ul className="list-none">
        {articles.map((article, index) => (
          <li key={index} className="text-p2 font-500 text-black border-b border-b-gray-200 border-solid py-2">
            <a href={article.href || '#'} className="link-animated-underline">{article.title}</a>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default SidebarRelated;
